import React from 'react';
import { useStyles } from './Footer.style';
import { BodyText } from '@lognex/ui-typography';
import { ContainerNew } from '@components/ContainerNew/ContainerNew.component';
import { ReactComponent as LogoIND } from '@assets/Catalog/Footer/logo-ind.svg';
import { ReactComponent as LogoRU } from '@assets/Catalog/Footer/logo-ru.svg';
import { TAppState, TAppEvents } from '@store/index';
import { Localizator } from '@utils/Localizator';
import { useStoreon } from 'storeon/react';

export const Footer = () => {
  const { classes } = useStyles();
  const { locale } = useStoreon<TAppState, TAppEvents>('locale');
  const { t } = Localizator.translate();

  return (
    <a
      href={t('Other.REFERRAL_LINK')}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.linkWrapper}
    >
      <ContainerNew className={classes.container}>
        <BodyText className={classes.text}>{t('Showcase.Footer')}</BodyText>
        {locale === 'ru-RU' ? (
          <LogoRU className={classes.logo} />
        ) : (
          <LogoIND className={classes.logo} />
        )}
      </ContainerNew>
    </a>
  );
};
